import { Navigate, useLocation } from 'react-router';

import { legacyAgentPathToHelpdesk } from '@/products/helpdesk/helpdesk-paths';

/** Keeps bookmarks, mail links and stored notification links working after the `/helpdesk` move. */
export function LegacyHelpdeskRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={{ pathname: legacyAgentPathToHelpdesk(pathname), search, hash }} replace />;
}
